(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/assets/javascripts/utils.js');
"use strict";

var _svs$core$config$data, _svs$core$config$data2;
const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
const isSelfService = (_svs$core$config$data = (_svs$core$config$data2 = svs.core.config.data.svsconfig) === null || _svs$core$config$data2 === void 0 ? void 0 : _svs$core$config$data2.isSelfService) !== null && _svs$core$config$data !== void 0 ? _svs$core$config$data : false;

const getCustomerId = async () => {
  var _customizedSettingsRe;
  if (!isLoggedIn) {
    return '';
  }
  const customizedSettingsRes = await svs.core.jupiter.callAsync({
    method: 'GET',
    path: '/player/2/customizedsettings'
  });
  const customerId = customizedSettingsRes === null || customizedSettingsRes === void 0 || (_customizedSettingsRe = customizedSettingsRes.response) === null || _customizedSettingsRe === void 0 || (_customizedSettingsRe = _customizedSettingsRe.customizedSettings) === null || _customizedSettingsRe === void 0 || (_customizedSettingsRe = _customizedSettingsRe.properties) === null || _customizedSettingsRe === void 0 ? void 0 : _customizedSettingsRe.customerId;
  if (!customerId) {
    throw new Error('Unable to fetch customerId via customizedSettings.');
  }
  return customerId;
};

const getAuthorizationCode = async () => {
  if (!isLoggedIn) {
    return '';
  }
  let path = '/oddset/1/launchparameters';
  const geoIpResponse = svs.oddset_kambi.data.geoIpResponse;
  if (geoIpResponse && geoIpResponse.country) {
    path += "?country=".concat(geoIpResponse.country);
  }
  const jupiterOptions = {
    method: 'GET',
    path
  };
  try {
    const launchParametersRes = await svs.core.jupiter.callAsync(jupiterOptions);
    const {
      authorizationCode
    } = launchParametersRes.response;
    return authorizationCode;
  } catch (error) {
    switch (error.code) {
      case 3001:
        svs.components.oddset.clientErrorHandler.errorDialogs.displayGenericErrorDialog(() => svs.utils.url.navigate('/'), 'Oddset är inte tillgängligt', 'Tyvärr går det inte att spela Oddset i landet du befinner dig i.');
        break;
      default:
        svs.components.oddset.clientErrorHandler.errorDialogs.displayGenericErrorDialog(() => svs.utils.url.navigate('/'), 'Oj då!', 'Något oväntat fel har inträffat när Oddset skulle öppnas');
        break;
    }
    throw new Error('Unable to fetch auth code via launchparameters.');
  }
};

const createParametersObj = _ref => {
  let {
    authorizationCode,
    customerId,
    customerIdPrefix,
    environment
  } = _ref;
  return {
    currency: 'SEK',
    locale: 'sv_SE',
    market: 'SE',
    playerId: isLoggedIn ? "".concat(customerIdPrefix).concat(customerId) : '',
    ticket: isLoggedIn ? authorizationCode : '',
    oddsFormat: 'decimal',
    streamingAllowedForPlayer: 'true',
    channelId: isSelfService ? 7 : undefined,
    retailMode: isSelfService ? true : undefined,
    racingMode: 'false',
    environment 
  };
};
setGlobal('svs.oddset_kambi.utils', {
  createParametersObj,
  getCustomerId,
  getAuthorizationCode
});

 })(window);